export default __webpack_public_path__ + "static/media/banner.374e8e03.png";